// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StepOne-module__colorBox--gJmPJ {
    margin: 20px 0;
    display: flex;
    gap: 10px;
    align-content: center;
    justify-content: center;
    align-items: center;
    background-color: #e2e9ff;
    border-radius: 20px;
    padding: 5px;
}

.StepOne-module__colorBox--gJmPJ>p {
    margin: 0;
}

.StepOne-module__icon--2G9qV>svg {
    color: var(--color-primary);
    font-size: 25px;
}

.StepOne-module__iconRub--q75mE>svg {
    font-size: 15px;
}

.StepOne-module__fullWidth--rzzQe {
    width: 100%;
}

.StepOne-module__btnDaData--viuOk {
    border-radius: 20px !important;
    background-color: #cbdbfa !important;
    text-transform: none !important;
    color: var(--color-primary) !important;
    height: 25px !important;
}

.StepOne-module__accordionBox--k5Ptj {
    margin-top: 20px;
}

.StepOne-module__iconList--U6Nrc {
    min-width: 30px !important;
}

.StepOne-module__iconList--U6Nrc>svg {
    width: 10px;
    color: var(--color-primary);
}

.StepOne-module__text--m_3YB>span {
    color: var(--color-primary);
    font-weight: bold;
    font-size: 17px;
}

.StepOne-module__countBox--B5hAt {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
}

.StepOne-module__btnGetSum--HEhbM {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.StepOne-module__priceBox--XWLAm {
    color: var(--color-title);
    display: flex;
    justify-content: center;
    align-items: center;
}

.StepOne-module__spanPrice--coelp,
.StepOne-module__spanIcon--ZJczk>svg {
    color: var(--color-primary);
    font-weight: bold;
    font-size: 25px;
}

.StepOne-module__accordionBoxDesktop--vPeUM {
    display: flex;
    gap: 20px;
    justify-content: center;
    align-items: center;
}

.StepOne-module__desktopBox--idFdA {
    display: flex;
    gap: 20px;
    justify-content: center;
    align-items: center;
}

.StepOne-module__desktopBox--idFdA>div {
    width: 50%;
}

.StepOne-module__desktopCountBox--AsXSj {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0;
}

.StepOne-module__desktopPromoBox--oubcv {
    display: flex;
    gap: 20px;
    justify-content: center;
    align-items: center;
}

.StepOne-module__desktopPromoBox--oubcv>div {
    width: 50%;
}

.StepOne-module__desktopContainer--Ju24S {
    display: flex;
    flex-direction: column;
}

.StepOne-module__desktopBtnGetSum--ezpz1 {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
}


.StepOne-module__desktopColorBox--GS_XT {
    width: 70%;
    margin: 20px auto;
    display: flex;
    gap: 10px;
    align-content: center;
    justify-content: center;
    align-items: center;
    background-color: #e2e9ff;
    border-radius: 20px;
    padding: 5px;
}

.StepOne-module__desktopColorBox--GS_XT>p {
    margin: 0;
}

.StepOne-module__desktopBanner--xehuX {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #326CFD;
    padding: 15px 0px;
    border-radius: 10px;
    margin: 10px auto;
    max-width: 800px;
    width: 100%;
}

.StepOne-module__desktopBannerTitle--xr5mZ {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    color: white;
    height: 340px;
}

.StepOne-module__desktopBannerTitle--xr5mZ h2 {
    margin: 0;
    font-size: 24px;
}

.StepOne-module__desktopBannerTitle--xr5mZ h4 {
    margin: 0;
    font-size: 16px;
}

.StepOne-module__desktopBannerImg--Vg5AL {
    display: flex;
    align-items: center;
}

.StepOne-module__desktopBannerImg--Vg5AL img {
    max-width: 100%;
    height: auto;
}

.StepOne-module__title--HuV0v {
    margin-top: 50px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    align-items: center;
}

.StepOne-module__title--HuV0v>h2 {
    font-size: 35px;
    font-weight: 500;
}

.StepOne-module__title--HuV0v>h4 {
    margin-top: 20px;
}

.StepOne-module__checkboxBox--b2Q5E {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 20px;
}

.StepOne-module__checkboxBox--b2Q5E>div {
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/features/mite-policy/step-1/StepOne.module.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,aAAa;IACb,SAAS;IACT,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,+BAA+B;IAC/B,sCAAsC;IACtC,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;;IAEI,2BAA2B;IAC3B,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;;AAGA;IACI,UAAU;IACV,iBAAiB;IACjB,aAAa;IACb,SAAS;IACT,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf","sourcesContent":[".colorBox {\r\n    margin: 20px 0;\r\n    display: flex;\r\n    gap: 10px;\r\n    align-content: center;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background-color: #e2e9ff;\r\n    border-radius: 20px;\r\n    padding: 5px;\r\n}\r\n\r\n.colorBox>p {\r\n    margin: 0;\r\n}\r\n\r\n.icon>svg {\r\n    color: var(--color-primary);\r\n    font-size: 25px;\r\n}\r\n\r\n.iconRub>svg {\r\n    font-size: 15px;\r\n}\r\n\r\n.fullWidth {\r\n    width: 100%;\r\n}\r\n\r\n.btnDaData {\r\n    border-radius: 20px !important;\r\n    background-color: #cbdbfa !important;\r\n    text-transform: none !important;\r\n    color: var(--color-primary) !important;\r\n    height: 25px !important;\r\n}\r\n\r\n.accordionBox {\r\n    margin-top: 20px;\r\n}\r\n\r\n.iconList {\r\n    min-width: 30px !important;\r\n}\r\n\r\n.iconList>svg {\r\n    width: 10px;\r\n    color: var(--color-primary);\r\n}\r\n\r\n.text>span {\r\n    color: var(--color-primary);\r\n    font-weight: bold;\r\n    font-size: 17px;\r\n}\r\n\r\n.countBox {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin-top: 20px;\r\n}\r\n\r\n.btnGetSum {\r\n    margin-top: 20px;\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n}\r\n\r\n.priceBox {\r\n    color: var(--color-title);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.spanPrice,\r\n.spanIcon>svg {\r\n    color: var(--color-primary);\r\n    font-weight: bold;\r\n    font-size: 25px;\r\n}\r\n\r\n.accordionBoxDesktop {\r\n    display: flex;\r\n    gap: 20px;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.desktopBox {\r\n    display: flex;\r\n    gap: 20px;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.desktopBox>div {\r\n    width: 50%;\r\n}\r\n\r\n.desktopCountBox {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin-top: 0;\r\n}\r\n\r\n.desktopPromoBox {\r\n    display: flex;\r\n    gap: 20px;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.desktopPromoBox>div {\r\n    width: 50%;\r\n}\r\n\r\n.desktopContainer {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.desktopBtnGetSum {\r\n    margin-top: 20px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n\r\n.desktopColorBox {\r\n    width: 70%;\r\n    margin: 20px auto;\r\n    display: flex;\r\n    gap: 10px;\r\n    align-content: center;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background-color: #e2e9ff;\r\n    border-radius: 20px;\r\n    padding: 5px;\r\n}\r\n\r\n.desktopColorBox>p {\r\n    margin: 0;\r\n}\r\n\r\n.desktopBanner {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    background-color: #326CFD;\r\n    padding: 15px 0px;\r\n    border-radius: 10px;\r\n    margin: 10px auto;\r\n    max-width: 800px;\r\n    width: 100%;\r\n}\r\n\r\n.desktopBannerTitle {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    color: white;\r\n    height: 340px;\r\n}\r\n\r\n.desktopBannerTitle h2 {\r\n    margin: 0;\r\n    font-size: 24px;\r\n}\r\n\r\n.desktopBannerTitle h4 {\r\n    margin: 0;\r\n    font-size: 16px;\r\n}\r\n\r\n.desktopBannerImg {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.desktopBannerImg img {\r\n    max-width: 100%;\r\n    height: auto;\r\n}\r\n\r\n.title {\r\n    margin-top: 50px;\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-content: center;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.title>h2 {\r\n    font-size: 35px;\r\n    font-weight: 500;\r\n}\r\n\r\n.title>h4 {\r\n    margin-top: 20px;\r\n}\r\n\r\n.checkboxBox {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n    margin-top: 20px;\r\n}\r\n\r\n.checkboxBox>div {\r\n    width: 100%;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colorBox": `StepOne-module__colorBox--gJmPJ`,
	"icon": `StepOne-module__icon--2G9qV`,
	"iconRub": `StepOne-module__iconRub--q75mE`,
	"fullWidth": `StepOne-module__fullWidth--rzzQe`,
	"btnDaData": `StepOne-module__btnDaData--viuOk`,
	"accordionBox": `StepOne-module__accordionBox--k5Ptj`,
	"iconList": `StepOne-module__iconList--U6Nrc`,
	"text": `StepOne-module__text--m_3YB`,
	"countBox": `StepOne-module__countBox--B5hAt`,
	"btnGetSum": `StepOne-module__btnGetSum--HEhbM`,
	"priceBox": `StepOne-module__priceBox--XWLAm`,
	"spanPrice": `StepOne-module__spanPrice--coelp`,
	"spanIcon": `StepOne-module__spanIcon--ZJczk`,
	"accordionBoxDesktop": `StepOne-module__accordionBoxDesktop--vPeUM`,
	"desktopBox": `StepOne-module__desktopBox--idFdA`,
	"desktopCountBox": `StepOne-module__desktopCountBox--AsXSj`,
	"desktopPromoBox": `StepOne-module__desktopPromoBox--oubcv`,
	"desktopContainer": `StepOne-module__desktopContainer--Ju24S`,
	"desktopBtnGetSum": `StepOne-module__desktopBtnGetSum--ezpz1`,
	"desktopColorBox": `StepOne-module__desktopColorBox--GS_XT`,
	"desktopBanner": `StepOne-module__desktopBanner--xehuX`,
	"desktopBannerTitle": `StepOne-module__desktopBannerTitle--xr5mZ`,
	"desktopBannerImg": `StepOne-module__desktopBannerImg--Vg5AL`,
	"title": `StepOne-module__title--HuV0v`,
	"checkboxBox": `StepOne-module__checkboxBox--b2Q5E`
};
export default ___CSS_LOADER_EXPORT___;
